<div class="account-side">
    <h5>user name</h5>
    <button class="btn btn-secondary btn-sm" (click)="logout()">{{ "LOGOUT" | translate | titlecase }}</button>
</div>

<nav class="nav flex-column">
    <li class="nav-item">
        <a class="nav-link" routerLinkActive="active" routerLink="/home" (click)="toggle()">
            <i class="fas fa-home"></i>
            <span>{{ "HOME" | translate | titlecase }}</span>
        </a>
    </li>

    <li class="nav-item dropdown" *ngIf="globals.checkUserHasPermission('ROLES - QUERY') || globals.checkUserHasPermission('USERS - QUERY')||
    globals.checkUserHasPermission('PROFILE - UPDATE')">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-cog"></i>
            <span>{{ "SECURITY" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">

            <a class="dropdown-item" routerLink="/roles" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('ROLES - QUERY')">
                {{ "ROLE" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/users" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('USERS - QUERY')">{{ "USERS" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/user/profile" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('PROFILE - UPDATE')">{{ "PROFILE" | translate | titlecase }}</a>
        </div>
    </li>

    <li class="nav-item dropdown" *ngIf="globals.checkUserHasPermission('LANGUAGES - QUERY') || globals.checkUserHasPermission('SYS_PARAMETERS - QUERY')||
    globals.checkUserHasPermission('MDL_PARAMETERS - QUERY') || globals.checkUserHasPermission('COUNTRIES - QUERY')||
    globals.checkUserHasPermission('REGIONS - QUERY') || globals.checkUserHasPermission('PROVINCES - QUERY')||
    globals.checkUserHasPermission('CITIES - QUERY')">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-chalkboard-teacher"></i>
            <span>{{ "SYSTEM" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/system/language" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('LANGUAGES - QUERY')">{{ "LANGUAGE" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/system/parameters" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('SYS_PARAMETERS - QUERY')">{{ "SYSTEM_PARAMETERS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/system/module-parameters" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('MDL_PARAMETERS - QUERY')">{{ "MODULE_PARAMERERS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/system/countries" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('COUNTRIES - QUERY')">{{ "COUNTRIES" | translate | titlecase
                }}</a>
            <a class="dropdown-item" routerLink="/system/regions" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('REGIONS - QUERY')">{{ "REGIONS" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/system/provincies" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('PROVINCES - QUERY')">{{ "PROVINCIES" | translate | titlecase
                }}</a>
            <a class="dropdown-item" routerLink="/system/cities" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('CITIES - QUERY')">{{ "CITIES" | translate | titlecase }}</a>
        </div>
    </li>

    <li class="nav-item dropdown" *ngIf="globals.checkUserHasPermission('ORGANIZATIONS - QUERY') || globals.checkUserHasPermission('LOCATIONS - QUERY')||
    globals.checkUserHasPermission('YEARS - QUERY') || globals.checkUserHasPermission('SUBJECTS - QUERY')||
    globals.checkUserHasPermission('GRADES - QUERY') ">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-atlas"></i>
            <span>{{ "ACADEMICS" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('ORGANIZATIONS - QUERY')"> {{ "ORGANIZATION" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('LOCATIONS - QUERY')"> {{ "LOCATIONS" | translate | titlecase
                }}</a>
            <a class="dropdown-item" routerLink="/academics/years" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('YEARS - QUERY')"> {{ "YEARS" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="enrolment/grade-subject" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('SUBJECTS - QUERY')"> {{
                "SEMESRER_COURSE" | translate |titlecase }}</a>
            <a class="dropdown-item" routerLink="/" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('GRADES - QUERY')"> {{ "GARADES" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/calender-day-type" (click)="toggle()"> {{
                "CALENDER_DAY_TYPES" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/academic-calendar" (click)="toggle()"> {{ "ACADEMIC_CALENDAR"
                | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/teacher" (click)="toggle()"> {{ "TEACHERS_LECTURES" |
                translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/teacher-courses" (click)="toggle()"> {{ "TEACHER_COURSE" |
                translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/courses-categories" (click)="toggle()"> {{
                "COURSES_CATEGORIES" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/mark-group" (click)="toggle()"> {{ "MARK_GROUP" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="academics/marks" (click)="toggle()"> {{ "MARKS" | translate | titlecase
                }}</a>
            <a class="dropdown-item" routerLink="/enrolment/courses" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('SUBJECTS - QUERY')"> {{
                "COURSES" | translate |titlecase }}</a>
        </div>
    </li>

    <!-- <li class="nav-item dropdown">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-graduation-cap"></i>
            <span> {{ "ADMISSION" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/admission/app-statuses"
                (click)="toggle()">{{ "APPLICATION_STATUS" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/app-marital-status"
                (click)="toggle()">{{ "MARTIAL_STATUS" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/mil-statuses"
                (click)="toggle()">{{ "MILITIRY_STATUS" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/live-with"
                (click)="toggle()">{{ "LIVING_WITH_DATA" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/family-members"
                (click)="toggle()">{{ "FAMILY_MEMBER" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/questions"
                (click)="toggle()">{{ "ADMISSION_QUESTION" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/chronic-disease"
                (click)="toggle()">{{ "CHRONIC_DISEASES" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/Registration"
                (click)="toggle()">{{ "REGISTRATION" | translate | titlecase  }}</a>
            <a class="dropdown-item" routerLink="/admission/basic-data"
                (click)="toggle()">{{ "CANDIDATE_ADMISSION" | translate | titlecase }}</a> -->

    <!-- <a class="dropdown-item" routerLink="/admission/basic-data" (click)="toggle()">Admission-Section1</a>
            <a class="dropdown-item" routerLink="/admission/section1" (click)="toggle()">Admission-Section2</a>
            <a class="dropdown-item" routerLink="/admission/section2" (click)="toggle()">Admission-Section3</a>
            <a class="dropdown-item" routerLink="/admission/section3" (click)="toggle()">Admission-Section4</a> -->
    <!-- <a class="dropdown-item" routerLink="/admission/candidate-inquiry"
                (click)="toggle()">{{ "ADMISSION_INQUIRY" | translate | titlecase }}</a> -->
    <!-- <a class="dropdown-item" routerLink="/admission/english-test"
                (click)="toggle()">{{ "ENGLISH_MOODLE_TEST" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/personal-interview"
                (click)="toggle()">{{ "ADMISSION_INTERVIEW" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/medical-check"
                (click)="toggle()">{{ "ADMISSION_MEDICAL" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/evaluate"
                (click)="toggle()">{{ "ADMISSION_EVALUATION" | translate | titlecase }}</a> -->

    <!-- <a class="dropdown-item" routerLink="" (click)="toggle()">{{"APPLICATION_STATUSES" | translate | titlecase }}</a> -->
    <!-- <a class="dropdown-item" routerLink="/admission/mil-statuses" (click)="toggle()">{{"MIL_STATUS" | translate | titlecase }}</a> -->
    <!-- <a class="dropdown-item" routerLink="/admission/family-members" (click)="toggle()">{{"FAMILY_MEMBER" | translate | titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/questions" (click)="toggle()">{{"QUESTIONS" | translate | titlecase }}</a> -->


    <!-- </div>
    </li> -->
    <!-- Sub menu solution -->
    <li class="nav-item dropdown" *ngIf="globals.checkUserHasPermission('APPLICATION_STATUS - QUERY') || globals.checkUserHasPermission('MARITAL_STATUS - QUERY')||
    globals.checkUserHasPermission('MILITARY_STATUS - QUERY') || globals.checkUserHasPermission('LIVE_WITH - QUERY')||
    globals.checkUserHasPermission('FAMILY_MEMBERS - QUERY') || globals.checkUserHasPermission('ADMISSION_QUESTIONS - QUERY')||
    globals.checkUserHasPermission('CHRONIC_DISEASES - QUERY')
    || globals.checkUserHasPermission('CANDIDATE_ADMISSION - CREATE')||
    globals.checkUserHasPermission('CANDIDATE_INQUIRY - QUERY') || globals.checkUserHasPermission('CANDIDATE_INQUIRY - MOODLE')||
    globals.checkUserHasPermission('CANDIDATE_INQUIRY - INTERVIEW') || globals.checkUserHasPermission('CANDIDATE_INQUIRY - MEDICAL')||
    globals.checkUserHasPermission('CANDIDATE_INQUIRY - EVALUATION')">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-graduation-cap"></i>
            <span>{{ "ADMISSION" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true" *ngIf="globals.checkUserHasPermission('APPLICATION_STATUS - QUERY') || globals.checkUserHasPermission('MARITAL_STATUS - QUERY')||
                globals.checkUserHasPermission('MILITARY_STATUS - QUERY') || globals.checkUserHasPermission('LIVE_WITH - QUERY')||
                globals.checkUserHasPermission('FAMILY_MEMBERS - QUERY') || globals.checkUserHasPermission('ADMISSION_QUESTIONS - QUERY')||
                globals.checkUserHasPermission('CHRONIC_DISEASES - QUERY')">
                <!-- <i class="fas fa-graduation-cap"></i> -->
                <span>{{ "ADMISSION_CONFIG" | translate | titlecase }}</span>
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
                <a class="dropdown-item" routerLink="/admission/app-statuses" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('APPLICATION_STATUS - QUERY')">{{ "APPLICATION_STATUS" |
                    translate | titlecase }}</a>
                <a class="dropdown-item" routerLink="/admission/app-marital-status" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('MARITAL_STATUS - QUERY')">{{ "MARTIAL_STATUS" | translate |
                    titlecase }}</a>
                <a class="dropdown-item" routerLink="/admission/mil-statuses" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('MILITARY_STATUS - QUERY')">{{ "MILITIRY_STATUS" | translate |
                    titlecase }}</a>
                <a class="dropdown-item" routerLink="/admission/live-with" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('LIVE_WITH - QUERY')">{{ "LIVING_WITH_DATA" | translate |
                    titlecase }}</a>
                <a class="dropdown-item" routerLink="/admission/family-members" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('FAMILY_MEMBERS - QUERY')">{{ "FAMILY_MEMBER" | translate |
                    titlecase }}</a>
                <a class="dropdown-item" routerLink="/admission/questions" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('ADMISSION_QUESTIONS - QUERY')">{{ "ADMISSION_QUESTION" |
                    translate | titlecase }}</a>
                <a class="dropdown-item" routerLink="/admission/chronic-disease" (click)="toggle()"
                    *ngIf="globals.checkUserHasPermission('CHRONIC_DISEASES - QUERY')">{{ "CHRONIC_DISEASES" | translate
                    | titlecase }}</a>

            </div>
            <!-- <a class="dropdown-item" routerLink="/Registration"
                (click)="toggle()">{{ "REGISTRATION" | translate | titlecase  }}</a> -->
            <!-- <a class="dropdown-item" routerLink="/admission/basic-data"
                (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('CANDIDATE_ADMISSION - CREATE')">{{ "CANDIDATE_ADMISSION" | translate | titlecase }}</a> -->

            <!-- <a class="dropdown-item" routerLink="/admission/basic-data" (click)="toggle()">Admission-Section1</a>
        <a class="dropdown-item" routerLink="/admission/section1" (click)="toggle()">Admission-Section2</a>
        <a class="dropdown-item" routerLink="/admission/section2" (click)="toggle()">Admission-Section3</a>
        <a class="dropdown-item" routerLink="/admission/section3" (click)="toggle()">Admission-Section4</a> -->
            <a class="dropdown-item" routerLink="/admission/candidate-inquiry" (click)="toggle()"
                *ngIf="globals.checkUserHasPermission('CANDIDATE_INQUIRY - QUERY')">{{ "ADMISSION_INQUIRY" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/admission/bulk-english-test" (click)="toggle()" *ngIf="true">{{
                "BULK_ENGLISH_TEST" | translate |
                titlecase }}</a>
        </div>
    </li>
<ng-container *ngIf="globals.isAdmin">
    <li class="nav-item dropdown" *ngIf="true">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="far fa-address-book"></i>
            <span>{{ "ENROLLMENT" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/enrolment/accepted-student" (click)="toggle()" *ngIf="true"> {{
                "ACCEPTED_STUDENT" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/enrolment/add-student" (click)="toggle()" *ngIf="true"> {{
                "ADD_STUDENT" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/enrolment/student-grouping" (click)="toggle()" *ngIf="true"> {{
                "STUDENT_GROUPING" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="enrolment/reports" (click)="toggle()" *ngIf="true"> {{
                "ENROLMENR_REPORT" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="enrolment/reports-group" (click)="toggle()" *ngIf="true"> {{
                "ENROLMENR_REPORT_GROUP" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="enrolment/semester-student-group" (click)="toggle()" *ngIf="true"> {{
                    "ENROLLMENT_GROUPS" | translate |
                    titlecase }}</a>    
        </div>
    </li>

    <li class="nav-item dropdown" *ngIf="true">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="far fa-solid fa-calendar"></i>
            <span>{{ "SCHEDULE" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="schedule/schedule-setup" (click)="toggle()" *ngIf="true"> {{
                "SCHEDULE_SETUP" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="schedule/schedule" (click)="toggle()" *ngIf="true"> {{
                "SCHEDULE" | translate |
                titlecase }}</a>
        </div>
    </li>

    <li class="nav-item dropdown" *ngIf="true">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-glass-martini"></i>
            <span>{{ "ATTENDANCE" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="attendence/type" (click)="toggle()" *ngIf="true"> {{
                "ATTENDANCE_TYPE" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="attendence/authorized-absence-request" (click)="toggle()" *ngIf="true">
                {{
                "AUTHORIZED_ABSENCE_REQUEST" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="attendence/daily-attendance" (click)="toggle()" *ngIf="true"> {{
                "DAILY_ATTENDENACE" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="attendence/available-dates" (click)="toggle()" *ngIf="true"> {{
                "AVAILABLE_DATES" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="attendence/exam-eligibility" (click)="toggle()" *ngIf="true"> {{
                "EXAM_ELIGIBILITY" | translate |
                titlecase }}</a>
        </div>
    </li>

    <li class="nav-item dropdown" *ngIf="true">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-tasks"></i>
            <span>{{ "SCORES_AND_GRADES" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/scores-grades/score-ranking" (click)="toggle()" *ngIf="true"> {{
                "SCORE_RANKING" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/assessment-units" (click)="toggle()" *ngIf="true"> {{
                "ASSESSMENT_UNITS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/warning-letters-type" (click)="toggle()" *ngIf="true">
                {{
                "WARNING_LETTERS_TYPE" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/course-assessment-units" (click)="toggle()"
                *ngIf="true"> {{
                "COURSE_ASSESSMENT_UNITS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/scores-data-upload" (click)="toggle()" *ngIf="true"> {{
                "SCORES_DATA_UPLOAD" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/student-eligiblity" (click)="toggle()" *ngIf="true"> {{
                "STUDENT_ELIGIBLITY" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/warning-letters" (click)="toggle()" *ngIf="true"> {{
                "WARNING_LETTERS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/scores-grades/reports" (click)="toggle()" *ngIf="true"> {{
                "REPORTS" | translate |
                titlecase }}</a>
        </div>
    </li>
    <li class="nav-item dropdown" *ngIf="true">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-book-open"></i>
            <span>{{ "EXAMS" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/exams/load-students" (click)="toggle()" *ngIf="true"> {{
                "LOAD_STUDENTS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/exams/review-and-release" (click)="toggle()" *ngIf="true"> {{
                "REVIEW_AND_RELEASE" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/exams/ongoing-examinations-reviewal" (click)="toggle()" *ngIf="true"> {{
                "ONGOING_EXAMINATIONS_REVIEWAL" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/exams/final-examinations" (click)="toggle()" *ngIf="true"> {{
                "FIAL_EXAMINATIONS" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/exams/cumulative-sheet-generation" (click)="toggle()" *ngIf="true"> {{
                "CUMULATIVE_SHEET_GENERATION" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/exams/re-take-exam" (click)="toggle()" *ngIf="true"> {{
                "RE_TAKE_EXAM" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="/exams/reports" (click)="toggle()" *ngIf="true"> {{
              "REPORTS" | translate |
              titlecase }}</a>
        </div>
    </li>

    <li class="nav-item dropdown" *ngIf="true">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false" (click)="globals.menuOpened = true">
            <i class="fas fa-file"></i>
            <span>{{ "REPORTS" | translate | titlecase }}</span>
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown" routerLinkActive="active">
            <a class="dropdown-item" routerLink="/report/summary-statistics" (click)="toggle()" *ngIf="true"> {{
                "SUMMARY_STATISTICS_REPORT" | translate |
                titlecase }}</a>
            <a class="dropdown-item" routerLink="report/cand-province" (click)="toggle()" *ngIf="true"> {{
                "CAND_PROVINCE_REPORT" | translate |
                titlecase }}</a>

        </div>
    </li>
</ng-container>

</nav>
